import "./App.css";
import MyDesktop from "./utils/MyDesktop";
import MyMobile from "./utils/MyMobile";
import Home from "./Components/Home";
import Desktop from "./assets/desktop.png";

function App() {
  return (
    <div className="container-fluid">
      <MyDesktop>
        <Home />
      </MyDesktop>
      <MyMobile>
        <div className="row" style={{ height: "100vh" }}>
          <div className="col-12 text-center d-flex align-items-center justify-content-center flex-column">
            <img
              src={Desktop}
              alt="desktop"
              height="auto"
              width="80%"
              style={{ borderRadius: "10px" }}
            />
            <h6 className="mt-3">Only Available on Desktop Screen</h6>
          </div>
        </div>
      </MyMobile>
    </div>
  );
}

export default App;
